import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useQueryParam = (name: string) => {
  const [params, setParams] = useSearchParams();

  return useMemo(
    () => ({
      value: params.get(name),
      set: (value: string) => {
        const newParams = new URLSearchParams(params);
        newParams.set(name, value);
        setParams(newParams);
      },
      clear: () => {
        const newParams = new URLSearchParams(params);
        newParams.delete(name);
        setParams(newParams);
      },
    }),
    [name, params, setParams]
  );
};
